/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewKeywordRequestDTO
 */
export interface NewKeywordRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof NewKeywordRequestDTO
     */
    serviceId?: number;
    /**
     * 
     * @type {string}
     * @memberof NewKeywordRequestDTO
     */
    value?: string;
}

export function NewKeywordRequestDTOFromJSON(json: any): NewKeywordRequestDTO {
    return NewKeywordRequestDTOFromJSONTyped(json, false);
}

export function NewKeywordRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewKeywordRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serviceId': !exists(json, 'serviceId') ? undefined : json['serviceId'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function NewKeywordRequestDTOToJSON(value?: NewKeywordRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serviceId': value.serviceId,
        'value': value.value,
    };
}

